// import { Backdrop, Divider, Grid, Table, TableBody, TableCell, TableContainer, TableFooter, TableHead, TableRow, Typography } from '@mui/material';
// import React, { Fragment, memo, useEffect, useRef, useState } from 'react';
// import { Br, Cut, Line, Printer, Text, Row, render } from 'react-thermal-printer';
// import { useStyle } from './style';
// import moment from 'moment';
// import { useDispatch, useSelector } from 'react-redux';
// import { resetData } from '../../hooks/printPdf/thermalData';
// import { useNavigate } from 'react-router-dom';
// import _ from 'lodash';
// import { setSnackbar } from '../../hooks/snackBar/reducers';

// const ThermalPrint = () => {
//     const data = useSelector(state => state.getThermalData)
//     const dispatch = useDispatch()
//     const navigate = useNavigate()
//     const classes = useStyle()
//     const [text, setText] = useState("Baby Corn 5 Kg")
//     const [flag, setFlag] = useState(false)
//     const [gst,setGst] = useState([])
//     const [gData, setGData] = useState([])

//     console.log('vanthuden', data)
    
//     useEffect(()=>{
//         if(data.onPress){
//             console.log('vanthuden', data)
//           if(data.getThermalData!==null ){
//             // printableDiv.classList.add('printPDF')
//             // printableDiv.classList.remove('printPDF')
//             console.log(data.getThermalData.companyInfo.docno, 'Enna ithu')
//             const docBill = data.getThermalData.companyInfo.docno
//             console.log(docBill.replace("_", "/").replace("_", "-").replace("_", "/"))
//             const groupedData = _.groupBy(data.getThermalData.tableData,'cgstPerc')
//             const result = _.map(groupedData,(val,tax)=>({
//                 cgstPerc : parseFloat(tax),
//                 gstAmt : _.sumBy(val, item=> parseFloat(item.cgstAmnt))
//             }))
//             const groupData = _.groupBy(data.getThermalData.tableData, item => `${item.cat_name}_${item.category_name}_${item.hsn}_${item.mrp}_${item.sale_rate}_${item.cgstPerc}`)
//             console.log(groupData)
//             const getGroupData = _.map(groupData,(val,tax)=>({
//                 cat_name : val[0].cat_name,
//                 category_name : val[0].category_name,
                
//                 hsn : val[0].hsn,
//                 qty : _.sumBy(val, item=> parseFloat(item.qty)),
//                 sale_rate : val[0].sale_rate,
//                 mrp: val[0].mrp,
//                 totalAmt: _.sumBy(val, item=> parseFloat(item.totalAmt)),
//                 cgstAmnt : _.sumBy(val, item=> parseFloat(item.cgstAmnt)),
//                 cgstPerc: val[0].cgstPerc,
//                 disc1: val[0].disc1,
//                 // pur_rate: val[0].pur_rate,
//             }))
//             setGData(getGroupData)
//             setGst(result)
//             setFlag(true)
//           }
//         }
      
//     },[data])
//     useEffect(()=>{
//       if(flag){
//         window.print()
//         dispatch(resetData())
//         dispatch(setSnackbar(true,'success','Sales order processed successfully!'))
//         navigate(-1)
//         setFlag(false)
//       }
//     },[flag])
// return(
// <div>
// {data.onPress && 
//     <div style={{backgroundColor:'white', position : 'absolute', zIndex:1150, top:0,left : 0,  padding: 1}}>
// <Printer type="epson" width={42}>
// <Typography sx={{color:'black', textAlign : 'center', fontWeight: 600, fontSize:16}} textTransform="uppercase">{data.getThermalData.companyInfo.company_fullname}</Typography>
// <Typography sx={{color:'black', textAlign : 'center', fontWeight: 600, fontSize:14}}>{data.getThermalData.companyInfo.outlet_acname}</Typography>
// <Typography sx={{color:'black', textAlign : 'center', fontWeight: 600, fontSize:14}}>{data.getThermalData.companyInfo.outlet_fullname}</Typography>
// <Typography sx={{ color:'black',textAlign : 'center',  textWrap:'wrap', fontSize:13}}>{data.getThermalData.companyInfo.outlet_add1}</Typography>
// <Typography sx={{ color:'black',textAlign : 'center',  textWrap:'wrap', fontSize:13}}>{data.getThermalData.companyInfo.outlet_add2}</Typography>
// <Typography sx={{ color:'black',textAlign : 'center',  textWrap:'wrap', fontSize:13}}>Mobile : +91{data.getThermalData.companyInfo.outlet_phone}</Typography>
// <Typography fontWeight={600} sx={{ color:'black', textAlign : 'center',  textWrap:'wrap',  fontSize:13}}>GSTIN - {data.getThermalData.companyInfo.outlet_gstin}</Typography>
// {data.getThermalData.companyInfo.outlet_type_name==='OTHERS' && <Typography sx={{ color:'black',textAlign : 'center', fontWeight: 660,fontSize:13}}>Bill of Supply</Typography>}

// <div style={{display : 'flex', justifyContent:'space-between', marginBlock: 1}}>
// <Typography sx={{color:'black', fontWeight:600, fontSize: 10}}>Bill No : {data.getThermalData.companyInfo.docno.replace("_", "/").replace("_", "-").replace("_", "/")}</Typography>
// <Typography sx={{color:'black', fontWeight:600, fontSize: 10}}>Date : {moment(data.getThermalData.companyInfo.created_at).format('DD-MM-YYYY LT')}</Typography>
// </div>
// {/* <Text>--------------------------------------------</Text> */}
// <TableContainer sx={{paddingInline:1}}>
//     <Table>
//         <TableBody>
//         <TableRow>
//                 {/* <TableCell padding='checkbox' className={classes.headCell} sx={{minWidth: 30}}>S.no</TableCell> */}
//                 <TableCell className={classes.headCell} align='left' sx={{width:data.getThermalData.companyInfo.outlet_type_name!=='OTHERS' ? 70 : 90, fontWeight: 600, fontSize:12}}>Item</TableCell>
//                 <TableCell className={classes.headCell} align='center' sx={{width:40, fontWeight: 600}}>HSN</TableCell>
//                 {data.getThermalData.companyInfo.outlet_type_name!=='OTHERS' && <TableCell className={classes.headCell} align='center' sx={{width:30, fontWeight: 600}}>Tax</TableCell>}
//                 <TableCell className={classes.headCell} align='center'  sx={{width:40, fontWeight: 600}}>Qty</TableCell>
//                 <TableCell className={classes.headCell} align='center'  sx={{width:45, fontWeight: 600}}>Rate</TableCell>
//                 <TableCell className={classes.headCell} align='right'  sx={{width:50, fontWeight: 600}}>Amt</TableCell>
//             </TableRow>
//                 {_.map(gData,(val,idx)=>(
//                     // val.cat_name.length > 6 ?
//                     <TableRow key={idx} className={classes.tblRowCell}>
//                     {/* <TableCell padding='checkbox' >{idx + 1}</TableCell> */}
//                     <TableCell sx={{textWrap:'wrap'}}>{val.cat_name || val.category_name}</TableCell>
//                     {/* <TableCell sx={{textWrap:'wrap'}}>{val.cat_name}</TableCell> */}
//                     <TableCell align='left' >{val.hsn}</TableCell>
//                     {data.getThermalData.companyInfo.outlet_type_name!=='OTHERS' && <TableCell align='center' >{val.cgstPerc} %</TableCell>}
//                     <TableCell align='right'>{val.qty}</TableCell>
//                     <TableCell align='right'>{data.getThermalData.companyInfo.outlet_type_name!=='OTHERS' ? val.sale_rate : val.mrp}</TableCell>
//                     <TableCell align='right'>{data.getThermalData.companyInfo.outlet_type_name!=='OTHERS' ? parseFloat(val.totalAmt).toFixed(2) : parseFloat(parseFloat(val.totalAmt) + parseFloat(val.cgstAmnt)).toFixed(2)}</TableCell>
//                     </TableRow> 
//                 ))}
                      
// <TableRow>
//     <TableCell className={classes.headCell} colSpan={2}/>
//     {data.getThermalData.companyInfo.outlet_type_name!=='OTHERS' &&  <TableCell className={classes.headCell} />}
//     <TableCell className={classes.headCell} colSpan={2} align='left'  sx={{ color:'black', fontSize : 12}}>Total </TableCell>
//     <TableCell className={classes.headCell} colSpan={2}  align='right' sx={{fontWeight : 600, color:'black', fontSize : 17}}>{data.getThermalData.companyInfo.outlet_type_name!=='OTHERS' ? parseFloat(data.getThermalData.TotalData.sub_total).toFixed(2) : parseFloat(data.getThermalData.TotalData.sub_total + data.getThermalData.TotalData.gst ).toFixed(2)}</TableCell>
// </TableRow>
// <TableRow className={classes.tblRowCell}>
//     <TableCell sx={{fontWeight : 600, color:'black', fontSize : 17}}>Tot Qty</TableCell>
//     <TableCell sx={{textAlign:'left', color:'black'}} colSpan={data.getThermalData.companyInfo.outlet_type_name!=='OTHERS' ? 1 : 3}>{parseFloat(data.getThermalData.tableData.reduce((accumulator, currentValue) =>accumulator + currentValue.qty, 0)).toFixed(2)}</TableCell>
//     {data.getThermalData.companyInfo.outlet_type_name!=='OTHERS' && <TableCell className={classes.headCell} sx={{fontWeight : 600, color:'black', fontSize : 17}} colSpan={3}>Total Tax Amt</TableCell>}
//     {data.getThermalData.companyInfo.outlet_type_name!=='OTHERS' && <TableCell className={classes.headCell} align='right' sx={{ color:'black', }} >{parseFloat(data.getThermalData.tableData.reduce((accumulator, currentValue) =>accumulator + Number(currentValue.cgstAmnt), 0)).toFixed(2)}</TableCell>}
// </TableRow>

// <TableRow  className={classes.tblSubCell}>
//     <TableCell className={classes.headCell}/>
//     {data.getThermalData.companyInfo.outlet_type_name!=='OTHERS' && <TableCell className={classes.headCell}/>}
//     <TableCell className={classes.headCell} colSpan={2} align='left' sx={{ color:'black', fontSize : 14, fontWeight: 600}}>Grand Total</TableCell>
//     {/* <TableCell className={classes.headCell} colSpan={2} align='right' sx={{fontWeight : 600, color:'black', fontSize : 15}}>{parseFloat(data.getThermalData.TotalData.sub_total + data.getThermalData.TotalData.gst - data.getThermalData.companyInfo.discount_amount).toFixed(2)}</TableCell> */}
//     <TableCell 
//   className={classes.headCell} 
//   colSpan={2} 
//   align='right' 
//   sx={{ fontWeight: 600, color: 'black', fontSize: 15 }}
// >
//   {Math.round(
//     parseFloat(data.getThermalData.TotalData.sub_total) + 
//     parseFloat(data.getThermalData.TotalData.gst) +
//     parseFloat(data.getThermalData.companyInfo.discount_amount)
//   )}
// </TableCell>


// </TableRow>
// <TableRow  className={classes.tblSubCell}>
//     <TableCell className={classes.headCell}/>
//     {data.getThermalData.companyInfo.outlet_type_name!=='OTHERS' && <TableCell className={classes.headCell}/>}
//     <TableCell className={classes.headCell} colSpan={2} align='left' sx={{ color:'black', fontSize : 14, fontWeight: 600}}>Discount Amount</TableCell>
//     <TableCell className={classes.headCell} colSpan={2} align='right' sx={{fontWeight : 600, color:'black', fontSize : 15}}>{parseFloat(data.getThermalData.companyInfo.discount_amount ).toFixed(0)}</TableCell>
// </TableRow>
// {data.getThermalData.TotalData.returnAmnt!=="" && data.getThermalData.TotalData.returnAmnt!=='0.00' && data.getThermalData.TotalData.returnAmnt > 0 &&
//     <TableRow  className={classes.tblSubCell}>
//     <TableCell className={classes.headCell}/>
//     {data.getThermalData.companyInfo.outlet_type_name!=='OTHERS' && <TableCell className={classes.headCell}/>}
//     <TableCell className={classes.headCell} colSpan={3} align='left' sx={{ color:'black', fontSize : 14, fontWeight: 600}}>Sales Return Amt</TableCell>
//     <TableCell className={classes.headCell} colSpan={2} align='right' sx={{fontWeight : 600, color:'black', fontSize : 15}}>{parseFloat(data.getThermalData.TotalData.returnAmnt).toFixed(2)}</TableCell>
// </TableRow>}
// {/* {data.getThermalData.TotalData.returnAmnt!=="" && data.getThermalData.TotalData.returnAmnt!=='0.00' &&
//     <TableRow  className={classes.tblSubCell}>
//     <TableCell className={classes.headCell}/>
//     {data.getThermalData.companyInfo.outlet_type_name!=='OTHERS' && <TableCell className={classes.headCell}/>}
//     <TableCell className={classes.headCell} colSpan={3} align='left' sx={{ color:'black', fontSize : 14, fontWeight: 600}}>Amount</TableCell>
//     <TableCell className={classes.headCell} colSpan={2} align='right' sx={{fontWeight : 600, color:'black', fontSize : 15}}>
//         {Math.round(
//     parseFloat(data.getThermalData.TotalData.sub_total) + 
//     parseFloat(data.getThermalData.TotalData.gst) 
//   )}
//         </TableCell>

// </TableRow>} */}
// {data.getThermalData.redeemedValue != 0 && 
//     <TableRow>
//   <TableCell className={classes.headCell}/>
//     <TableCell className={classes.headCell} colSpan={3} align='left' sx={{ color:'black', fontSize : 14, fontWeight: 600}}>Redeemed Amount</TableCell>
//     <TableCell className={classes.headCell} colSpan={2} align='right' sx={{fontWeight : 600, color:'black', fontSize : 15}}>{Math.round(data.getThermalData.redeemedValue).toFixed(2)}</TableCell>
// </TableRow>
// }
// {data.getThermalData.lessAmount !== 0 &&
//     <TableRow>
//   <TableCell className={classes.headCell}/>
//     <TableCell className={classes.headCell} colSpan={3} align='left' sx={{ color:'black', fontSize : 14, fontWeight: 600}}>Less Amount</TableCell>
//     <TableCell className={classes.headCell} colSpan={2} align='right' sx={{fontWeight : 600, color:'black', fontSize : 15}}>{parseFloat(data.getThermalData.lessAmount).toFixed(2)}</TableCell>
// </TableRow>
// }

// <TableRow>
//   <TableCell className={classes.headCell}/>
//     <TableCell className={classes.headCell} colSpan={3} align='left' sx={{ color:'black', fontSize : 14, fontWeight: 600}}>Amount Received</TableCell>
//     {/* <TableCell className={classes.headCell} colSpan={2} align='right' sx={{fontWeight : 600, color:'black', fontSize : 15}}>{Math.round(data.getThermalData.TotalData.totalAmount - data.getThermalData.TotalData.returnAmnt).toFixed(2)}</TableCell>  */}
//     <TableCell className={classes.headCell} colSpan={2} align='right' sx={{fontWeight : 600, color:'black', fontSize : 15}}>
//         {/* {Math.round(data.getThermalData.TotalData.totalAmount - data.getThermalData.companyInfo.discount_amount ).toFixed(2)} */}
//         {Math.round(
//     parseFloat(data.getThermalData.TotalData.sub_total) + 
//     parseFloat(data.getThermalData.TotalData.gst) +
//     parseFloat(data.getThermalData.companyInfo.discount_amount) -data.getThermalData.companyInfo.discount_amount - data.getThermalData.companyInfo.loyalty_redem - data.getThermalData.companyInfo.less_amount
//   ) - parseFloat(data.getThermalData.TotalData.returnAmnt)
//   }
        
//         </TableCell> 
//     {/* <TableCell className={classes.headCell} colSpan={2} align='right' sx={{fontWeight : 600, color:'black', fontSize : 15}}>{Math.round(data.getThermalData.TotalData.totalAmount - data.getThermalData.companyInfo.discount_amount ).toFixed(2)}</TableCell>  */}

// </TableRow>
// {/* {data.getThermalData.companyInfo.outlet_type_name!=='OTHERS' &&
// <TableRow>
//   <TableCell className={classes.headCell}/>
//     <TableCell className={classes.headCell} colSpan={3} align='left' sx={{ color:'black', fontSize : 14, fontWeight: 600}}>Amount Received</TableCell>
//     <TableCell className={classes.headCell} colSpan={2} align='right' sx={{fontWeight : 600, color:'black', fontSize : 15}}>{Math.round(data.getThermalData.TotalData.totalAmount - data.getThermalData.companyInfo.discount_amount ).toFixed(2)}</TableCell> 

// </TableRow>} */}
// <TableRow className={classes.tblSubCell}>
//     <TableCell className={classes.headCell} colSpan={2} sx={{fontWeight : 600, color:'black', fontSize : 13}}>Mode of Payment</TableCell>
//     <TableCell className={classes.headCell} colSpan={2}/>
//     {data.getThermalData.companyInfo.outlet_type_name!=='OTHERS' && <TableCell className={classes.headCell}/>}
//     <TableCell className={classes.headCell} sx={{fontWeight : 600, color:'black', fontSize : 13}} align='right'>Amount</TableCell>
// </TableRow>
// <TableRow className={classes.tblSubCell}>
//     <TableCell colSpan={2} sx={{ color:'black', fontSize : 13, border:'none !important'}}>BY {(data.getThermalData.companyInfo.mode).toUpperCase()} -
//     {data.getThermalData.companyInfo.mode === "mixed" && 
//       <>
//        {Number(data.getThermalData.companyInfo.upi_amount) > 0 && " UPI"}

// {Number(data.getThermalData.companyInfo.card_amount ) > 0 && " CARD"}
// {Number(data.getThermalData.companyInfo.cash_amount ) > 0 && " CASH"}
//       </>
//       } 
    
//     </TableCell>
//     <TableCell colSpan={2} sx={{border:'none !important'}}/>
//     {data.getThermalData.companyInfo.outlet_type_name!=='OTHERS' && <TableCell sx={{border:'none !important'}}/>} 
//     <TableCell sx={{ color:'black', fontSize : 13, border:'none !important'}} align='right'>
//         {/* {parseFloat(data.getThermalData.TotalData.totalAmount - data.getThermalData.companyInfo.discount_amount).toFixed(2)} */}
//         {/* {Math.round(
//     parseFloat(data.getThermalData.TotalData.totalAmount) - 
//     parseFloat(data.getThermalData.companyInfo.discount_amount)
//   )} */}
//    {data.getThermalData.companyInfo.mode === 'card' && (

//             <span>
//                 {/* {Math.round(data.getThermalData.companyInfo.card_amount)} */}
//                 {Math.round(
//     parseFloat(data.getThermalData.TotalData.sub_total) + 
//     parseFloat(data.getThermalData.TotalData.gst) +
//     parseFloat(data.getThermalData.companyInfo.discount_amount) -data.getThermalData.companyInfo.discount_amount - data.getThermalData.companyInfo.loyalty_redem - data.getThermalData.companyInfo.less_amount
//   )- parseFloat(data.getThermalData.TotalData.returnAmnt)}
//             </span>
//         )}
//         {data.getThermalData.companyInfo.mode === 'cash' && (
//             <span>
//                 {/* {Math.round(data.getThermalData.companyInfo.cash_amount - data.getThermalData.companyInfo.discount_amount)} */}
             
//                   {Math.round(
//     parseFloat(data.getThermalData.TotalData.sub_total) + 
//     parseFloat(data.getThermalData.TotalData.gst) +
//     parseFloat(data.getThermalData.companyInfo.discount_amount) -data.getThermalData.companyInfo.discount_amount - data.getThermalData.companyInfo.loyalty_redem - data.getThermalData.companyInfo.less_amount
//   )- parseFloat(data.getThermalData.TotalData.returnAmnt)}
            
            
//             </span>
//         )}
//         {data.getThermalData.companyInfo.mode === 'upi' && (
//             <span>
//                 {/* {Math.round(data.getThermalData.companyInfo.upi_amount - data.getThermalData.companyInfo.discount_amount)} */}
//                 {Math.round(
//     parseFloat(data.getThermalData.TotalData.sub_total) + 
//     parseFloat(data.getThermalData.TotalData.gst) +
//     parseFloat(data.getThermalData.companyInfo.discount_amount) -data.getThermalData.companyInfo.discount_amount - data.getThermalData.companyInfo.loyalty_redem - data.getThermalData.companyInfo.less_amount
//   )- parseFloat(data.getThermalData.TotalData.returnAmnt)}
                
//                 </span>
//         )}
//         {data.getThermalData.companyInfo.mode === 'mixed' && (
//             <>
//                 {Number(data.getThermalData.companyInfo.card_amount) > 0 && (
//                     <div>
//                         {Math.round(data.getThermalData.companyInfo.card_amount )}
//                         {/* {Math.round(
//     parseFloat(data.getThermalData.TotalData.sub_total) + 
//     parseFloat(data.getThermalData.TotalData.gst) +
//     parseFloat(data.getThermalData.companyInfo.discount_amount) -data.getThermalData.companyInfo.discount_amount
//   )} */}
                        
//                         </div>
//                 )}
//                 {Number(data.getThermalData.companyInfo.upi_amount) > 0 && (
//                     <div>
//                         {Math.round(data.getThermalData.companyInfo.upi_amount)}
//                         {/* {Math.round(
//     parseFloat(data.getThermalData.TotalData.sub_total) + 
//     parseFloat(data.getThermalData.TotalData.gst) +
//     parseFloat(data.getThermalData.companyInfo.discount_amount) -data.getThermalData.companyInfo.discount_amount
//   )} */}
//                         </div>
//                 )}
//                 {Number(data.getThermalData.companyInfo.cash_amount) > 0 && (
//                     <div>
//                         {Math.round(data.getThermalData.companyInfo.cash_amount)}
//                         {/* {Math.round(
//     parseFloat(data.getThermalData.TotalData.sub_total) + 
//     parseFloat(data.getThermalData.TotalData.gst) +
//     parseFloat(data.getThermalData.companyInfo.discount_amount) -data.getThermalData.companyInfo.discount_amount
//   )} */}
//                         </div>
//                 )}
//             </>
//         )}
//    {/* {data.getThermalData.companyInfo.mode === 'card' && (

//             <span>{Math.round(data.getThermalData.companyInfo.card_amount)}</span>
//         )}
//         {data.getThermalData.companyInfo.mode === 'cash' && (
//             <span>{Math.round(data.getThermalData.companyInfo.cash_amount - data.getThermalData.companyInfo.discount_amount)}</span>
//         )}
//         {data.getThermalData.companyInfo.mode === 'upi' && (
//             <span>{Math.round(data.getThermalData.companyInfo.upi_amount - data.getThermalData.companyInfo.discount_amount)}</span>
//         )}
//         {data.getThermalData.companyInfo.mode === 'mixed' && (
//             <>
//                 {Number(data.getThermalData.companyInfo.card_amount) > 0 && (
//                     <div>{Math.round(data.getThermalData.companyInfo.card_amount - data.getThermalData.companyInfo.discount_amount)}</div>
//                 )}
//                 {Number(data.getThermalData.companyInfo.upi_amount) > 0 && (
//                     <div>{Math.round(data.getThermalData.companyInfo.upi_amount - data.getThermalData.companyInfo.discount_amount)}</div>
//                 )}
//                 {Number(data.getThermalData.companyInfo.cash_amount) > 0 && (
//                     <div>{Math.round(data.getThermalData.companyInfo.cash_amount - data.getThermalData.companyInfo.discount_amount)}</div>
//                 )}
//             </>
//         )} */}
//         </TableCell>
//     {/* <TableCell sx={{ color:'black', fontSize : 13, border:'none !important'}} align='right'>{parseFloat(data.getThermalData.TotalData.totalAmount - data.getThermalData.TotalData.returnAmnt).toFixed(2)}</TableCell> */}

// </TableRow>
//         </TableBody>
  
//     </Table>
// </TableContainer>

// {data.getThermalData.companyInfo.outlet_type_name!=='OTHERS' &&
// <TableContainer sx={{padding:1, color: 'black',}}>
//     <Table>
//         <TableHead >
//            <TableRow >
//            <TableCell className={classes.headCell}>Tax %</TableCell>
//             <TableCell align='center'sx={{color:'black'}} className={classes.headCell}>CGST</TableCell>
//             <TableCell align='center'sx={{color:'black'}} className={classes.headCell}>SGST</TableCell>
//             <TableCell align='right'sx={{color:'black'}} className={classes.headCell}>Total</TableCell>
//            </TableRow>
//         </TableHead>
//         <TableBody>
//         {_.map(gst,(val,idx)=>(
//             <TableRow className={classes.tblRowCell} key={idx}>
//                 <TableCell sx={{color:'black'}}>{parseFloat(val.cgstPerc).toFixed(2)}</TableCell>
//                 <TableCell sx={{color:'black'}} align='right'>{parseFloat(val.gstAmt / 2).toFixed(2)}</TableCell>
//                 <TableCell sx={{color:'black'}}align='right'>{parseFloat(val.gstAmt / 2).toFixed(2)}</TableCell>
//                 <TableCell sx={{color:'black'}}align='right'>{parseFloat(val.gstAmt).toFixed(2)}</TableCell>
//             </TableRow>
//         ))}
//         <TableRow className={classes.tblSubCell}>
//             <TableCell className={classes.headCell}>Total</TableCell>
//             <TableCell align='right' className={classes.headCell}>{parseFloat((data.getThermalData.tableData.reduce((accumulator, currentValue) =>accumulator + Number(currentValue.cgstAmnt), 0) / 2)).toFixed(2)}</TableCell>
//             <TableCell align='right' className={classes.headCell}>{parseFloat((data.getThermalData.tableData.reduce((accumulator, currentValue) =>accumulator + Number(currentValue.cgstAmnt), 0) / 2)).toFixed(2)}</TableCell>
//             <TableCell align='right' className={classes.headCell}>{parseFloat(data.getThermalData.tableData.reduce((accumulator, currentValue) =>accumulator + Number(currentValue.cgstAmnt), 0)).toFixed(2)}</TableCell>
//         </TableRow>
//         </TableBody>
//     </Table>
// </TableContainer>
// }
// {data.getThermalData.companyInfo.outlet_type_name=='OTHERS' && <Divider sx={{ backgroundColor:'black', margin:1}}/> }
// <Fragment>
// {data.getThermalData.companyInfo.outlet_type_name=='OTHERS' && <Typography fontWeight={600} width={300} align='center' flexWrap='wrap' sx={{color:'black'}}>Composition Dealer: Not eligible to collect tax on supplies</Typography> }
// <Typography  fontWeight={600} fontSize={12} marginLeft={2} sx={{color:'black'}}>Terms and Condition:</Typography>
// <Typography  fontWeight={600} fontSize={12} marginLeft={2} sx={{color:'black'}}>*Goods received in good condition.</Typography>
// <Typography  fontWeight={600} fontSize={12} marginLeft={2} sx={{color:'black'}}>*No exchange and No Return</Typography>
// </Fragment>

// <Typography textAlign='center'fontWeight={600} sx={{color:'black', fontSize: 13}}>Order Online: www.buygirlush.com</Typography>
// <Typography textAlign='center'fontWeight={600} sx={{ color:'black',fontSize: 13}}>***  THANK YOU! VISIT AGAIN ***</Typography>
// <Cut />

// </Printer>
// </div>}
// </div>
// )
// }

// export default memo(ThermalPrint)

import { Backdrop, Divider, Grid, Table, TableBody, TableCell, TableContainer, TableFooter, TableHead, TableRow, Typography } from '@mui/material';
import React, { Fragment, memo, useEffect, useState } from 'react';
import { Br, Cut, Printer } from 'react-thermal-printer';
import { useStyle } from './style';
import moment from 'moment';
import { useDispatch, useSelector } from 'react-redux';
import { resetData } from '../../hooks/printPdf/thermalData';
import { useNavigate } from 'react-router-dom';
import _ from 'lodash';
import { setSnackbar } from '../../hooks/snackBar/reducers';

const ThermalPrint = () => {
    const data = useSelector(state => state.getThermalData);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const classes = useStyle();
    const [flag, setFlag] = useState(false);
    const [gst, setGst] = useState([]);
    const [gData, setGData] = useState([]);

    const outletAcName = data.getThermalData?.companyInfo?.outlet_acname?.toLowerCase();
    const isOthersEnterprise =
        data.getThermalData?.companyInfo?.outlet_type_name === 'OTHERS' &&
        (outletAcName === 'latha enterprises' || outletAcName === 'diya enterprises');

    const hideAmountColumn = (outletAcName === 'latha enterprises' || outletAcName === 'diya enterprises');

    useEffect(() => {
        if (data.onPress) {
            if (data.getThermalData !== null) {
                const groupedData = _.groupBy(data.getThermalData.tableData, 'cgstPerc');
                const result = _.map(groupedData, (val, tax) => ({
                    cgstPerc: parseFloat(tax),
                    gstAmt: _.sumBy(val, item => parseFloat(item.cgstAmnt)),
                }));
                const groupData = _.groupBy(data.getThermalData.tableData, item =>
                   ` ${item.cat_name}_${item.category_name}_${item.hsn}_${item.mrp}_${item.sale_rate}_${item.cgstPerc}
               ` );
                const getGroupData = _.map(groupData, (val) => ({
                    cat_name: val[0].cat_name,
                    category_name: val[0].category_name,
                    hsn: val[0].hsn,
                    qty: _.sumBy(val, item => parseFloat(item.qty)),
                    sale_rate: val[0].sale_rate,
                    mrp: val[0].mrp,
                    totalAmt: _.sumBy(val, item => parseFloat(item.totalAmt)),
                    cgstAmnt: _.sumBy(val, item => parseFloat(item.cgstAmnt)),
                    cgstPerc: val[0].cgstPerc,
                    disc1: val[0].disc1,
                }));
                setGData(getGroupData);
                setGst(result);
                setFlag(true);
            }
        }
    }, [data]);

    useEffect(() => {
        if (flag) {
            window.print();
            dispatch(resetData());
            dispatch(setSnackbar(true, 'success', 'Sales order processed successfully!'));
            navigate(-1);
            setFlag(false);
        }
    }, [flag]);

    return (
        <div>
            {data.onPress &&
                <div style={{ backgroundColor: 'white', position: 'absolute', zIndex: 1150, top: 0, left: 0, padding: 1 }}>
                    <Printer type="epson" width={42}>
                        <Typography sx={{ color: 'black', textAlign: 'center', fontWeight: 600, fontSize: 16 }} textTransform="uppercase">{data.getThermalData.companyInfo.company_fullname}</Typography>
                        <Typography sx={{ color: 'black', textAlign: 'center', fontWeight: 600, fontSize: 14 }}>{data.getThermalData.companyInfo.outlet_acname}</Typography>
                        <Typography sx={{ color: 'black', textAlign: 'center', fontWeight: 600, fontSize: 14 }}>{data.getThermalData.companyInfo.outlet_fullname}</Typography>
                        <Typography sx={{ color: 'black', textAlign: 'center', textWrap: 'wrap', fontSize: 13 }}>{data.getThermalData.companyInfo.outlet_add1}</Typography>
                        <Typography sx={{ color: 'black', textAlign: 'center', textWrap: 'wrap', fontSize: 13 }}>{data.getThermalData.companyInfo.outlet_add2}</Typography>
                        <Typography sx={{ color: 'black', textAlign: 'center', textWrap: 'wrap', fontSize: 13 }}>Mobile : +91{data.getThermalData.companyInfo.outlet_phone}</Typography>
                        <Typography fontWeight={600} sx={{ color: 'black', textAlign: 'center', textWrap: 'wrap', fontSize: 13 }}>GSTIN - {data.getThermalData.companyInfo.outlet_gstin}</Typography>

                        {isOthersEnterprise && <Typography sx={{ color: 'black', textAlign: 'center', fontWeight: 660, fontSize: 13 }}>Bill of Supply</Typography>}
                        <div style={{display : 'flex', justifyContent:'space-between', marginBlock: 1}}>
                         <Typography sx={{color:'black', fontWeight:600, fontSize: 10}}>Bill No : {data.getThermalData.companyInfo.docno.replace("_", "/").replace("_", "-").replace("_", "/")}</Typography>
                         <Typography sx={{color:'black', fontWeight:600, fontSize: 10}}>Date : {moment(data.getThermalData.companyInfo.created_at).format('DD-MM-YYYY LT')}</Typography>
                        </div>

                        <TableContainer sx={{ paddingInline: 1 }}>
                            <Table>
                                <TableBody>
                                    <TableRow>
                                        <TableCell className={classes.headCell} align='left' sx={{ width: !isOthersEnterprise ? 70 : 90, fontWeight: 600, fontSize: 12 }}>Item</TableCell>
                                        <TableCell className={classes.headCell} align='center' sx={{ width: 40, fontWeight: 600 }}>HSN</TableCell>
                                        {!isOthersEnterprise && <TableCell className={classes.headCell} align='center' sx={{ width: 30, fontWeight: 600 }}>Tax</TableCell>}
                                        <TableCell className={classes.headCell} align='center' sx={{ width: 40, fontWeight: 600 }}>Qty</TableCell>
                                         <TableCell className={classes.headCell} align='center' sx={{ width: 40, fontWeight: 600 }}></TableCell>
                                        <TableCell className={classes.headCell}  align='right' sx={{ width: 60, fontWeight: 600 }}>
                                           Amt
                                        </TableCell>
                                    </TableRow>
                                    {_.map(gData, (val, idx) => (
                                        <TableRow key={idx} className={classes.tblRowCell}>
                                            <TableCell sx={{ textWrap: 'wrap' }}>{val.cat_name || val.category_name}</TableCell>
                                            <TableCell align='left'>{val.hsn}</TableCell>
                                            {!isOthersEnterprise && <TableCell align='center'>{val.cgstPerc} %</TableCell>}
                                            <TableCell align='right'>{val.qty}</TableCell>
                                              <TableCell align='right'></TableCell>
                                            <TableCell align='right' sx={{ width: 60 }}>
                                              
                                                         {/* {parseFloat(val.totalAmt + 1 * val.cgstAmnt).toFixed(2)} */}
                                                         {isOthersEnterprise ? parseFloat(val.totalAmt + 1 * val.cgstAmnt).toFixed(2)  : parseFloat(val.totalAmt).toFixed(2)}
                                                  
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                    <TableRow>
                                        <TableCell className={classes.headCell} colSpan={2} />
                                        {!isOthersEnterprise && <TableCell className={classes.headCell} />}
                                        <TableCell className={classes.headCell} colSpan={2} align='left' sx={{ color: 'black', fontSize: 12 }}>Total </TableCell>
                                        <TableCell
                                            className={classes.headCell}
                                            colSpan={2}
                                            align='right'
                                            sx={{ fontWeight: 600, color: 'black', fontSize: 17 }}
                                        >
                                            {!isOthersEnterprise
                                                ? parseFloat(data.getThermalData.TotalData.sub_total).toFixed(2)
                                                : parseFloat(data.getThermalData.TotalData.sub_total + data.getThermalData.TotalData.gst).toFixed(2)}
                                        </TableCell>
                                    </TableRow>

                                    <TableRow className={classes.tblRowCell}>
                                        <TableCell sx={{ fontWeight: 600, color: 'black', fontSize: 17 }}>Tot Qty</TableCell>
                                        <TableCell sx={{ textAlign: 'left', color: 'black' }} colSpan={!isOthersEnterprise ? 1 : 3}>{parseFloat(data.getThermalData.tableData.reduce((acc, current) => acc + current.qty, 0)).toFixed(2)}</TableCell>
                                        {!isOthersEnterprise && <TableCell className={classes.headCell} sx={{ fontWeight: 600, color: 'black', fontSize: 17 }} colSpan={3}>Total Tax Amt</TableCell>}
                                        {!isOthersEnterprise && <TableCell className={classes.headCell} align='right' sx={{ color: 'black' }} >{parseFloat(data.getThermalData.tableData.reduce((acc, curr) => acc + Number(curr.cgstAmnt), 0)).toFixed(2)}</TableCell>}
                                    </TableRow>

                                    <TableRow className={classes.tblSubCell}>
                                        <TableCell className={classes.headCell} />
                                        {!isOthersEnterprise && <TableCell className={classes.headCell} />}
                                        <TableCell className={classes.headCell} colSpan={2} align='left' sx={{ color: 'black', fontSize: 14, fontWeight: 600 }}>Grand Total</TableCell>
                                        <TableCell
                                            className={classes.headCell}
                                            colSpan={2}
                                            align='right'
                                            sx={{ fontWeight: 600, color: 'black', fontSize: 15 }}
                                        >
                                            {Math.round(
                                                parseFloat(data.getThermalData.TotalData.sub_total) +
                                                parseFloat(data.getThermalData.TotalData.gst) +
                                                parseFloat(data.getThermalData.companyInfo.discount_amount)
                                            )}
                                        </TableCell>
                                    </TableRow>

                                    <TableRow className={classes.tblSubCell}>
                                        <TableCell className={classes.headCell} />
                                        {!isOthersEnterprise && <TableCell className={classes.headCell} />}
                                        <TableCell className={classes.headCell} colSpan={2} align='left' sx={{ color: 'black', fontSize: 14, fontWeight: 600 }}>Discount Amount</TableCell>
                                        <TableCell className={classes.headCell} colSpan={2} align='right' sx={{ fontWeight: 600, color: 'black', fontSize: 15 }}>
                                            {parseFloat(data.getThermalData.companyInfo.discount_amount).toFixed(0)}
                                        </TableCell>
                                    </TableRow>

                                    {data.getThermalData.TotalData.returnAmnt !== "" && data.getThermalData.TotalData.returnAmnt !== '0.00' && data.getThermalData.TotalData.returnAmnt > 0 &&
                                        <TableRow className={classes.tblSubCell}>
                                            <TableCell className={classes.headCell} />
                                            {!isOthersEnterprise && <TableCell className={classes.headCell} />}
                                            <TableCell className={classes.headCell} colSpan={3} align='left' sx={{ color: 'black', fontSize: 14, fontWeight: 600 }}>Sales Return Amt</TableCell>
                                            <TableCell className={classes.headCell} colSpan={2} align='right' sx={{ fontWeight: 600, color: 'black', fontSize: 15 }}>
                                                {parseFloat(data.getThermalData.TotalData.returnAmnt).toFixed(2)}
                                            </TableCell>
                                        </TableRow>}

                                    {data.getThermalData.redeemedValue !== 0 &&
                                        <TableRow>
                                            <TableCell className={classes.headCell} />
                                            <TableCell className={classes.headCell} colSpan={3} align='left' sx={{ color: 'black', fontSize: 14, fontWeight: 600 }}>Redeemed Amount</TableCell>
                                            <TableCell className={classes.headCell} colSpan={2} align='right' sx={{ fontWeight: 600, color: 'black', fontSize: 15 }}>
                                                {Math.round(data.getThermalData.redeemedValue).toFixed(2)}
                                            </TableCell>
                                        </TableRow>
                                    }

                                    {data.getThermalData.lessAmount !== 0 &&
                                        <TableRow>
                                            <TableCell className={classes.headCell} />
                                            <TableCell className={classes.headCell} colSpan={3} align='left' sx={{ color: 'black', fontSize: 14, fontWeight: 600 }}>Less Amount</TableCell>
                                            <TableCell className={classes.headCell} colSpan={2} align='right' sx={{ fontWeight: 600, color: 'black', fontSize: 15 }}>
                                                {parseFloat(data.getThermalData.lessAmount).toFixed(2)}
                                            </TableCell>
                                        </TableRow>
                                    }

                                    <TableRow>
                                        <TableCell className={classes.headCell} />
                                        <TableCell className={classes.headCell} colSpan={3} align='left' sx={{ color: 'black', fontSize: 14, fontWeight: 600 }}>Amount Received</TableCell>
                                        <TableCell className={classes.headCell} colSpan={2} align='right' sx={{ fontWeight: 600, color: 'black', fontSize: 15 }}>
                                            {Math.round(
                                                parseFloat(data.getThermalData.TotalData.sub_total) +
                                                parseFloat(data.getThermalData.TotalData.gst) +
                                                parseFloat(data.getThermalData.companyInfo.discount_amount) -
                                                data.getThermalData.companyInfo.discount_amount -
                                                data.getThermalData.companyInfo.loyalty_redem -
                                                data.getThermalData.companyInfo.less_amount
                                            ) - parseFloat(data.getThermalData.TotalData.returnAmnt)}
                                        </TableCell>
                                    </TableRow>

                                    <TableRow className={classes.tblSubCell}>
                                        <TableCell className={classes.headCell} colSpan={2} sx={{ fontWeight: 600, color: 'black', fontSize: 13 }}>Mode of Payment</TableCell>
                                        <TableCell className={classes.headCell} colSpan={2} />
                                        {!isOthersEnterprise && <TableCell className={classes.headCell} />}
                                        <TableCell className={classes.headCell} sx={{ fontWeight: 600, color: 'black', fontSize: 13 }} align='right'>Amount</TableCell>
                                    </TableRow>
                                    <TableRow className={classes.tblSubCell}>
                                        <TableCell colSpan={2} sx={{ color: 'black', fontSize: 13, border: 'none !important' }}>BY {(data.getThermalData.companyInfo.mode).toUpperCase()} -
                                            {data.getThermalData.companyInfo.mode === "mixed" &&
                                                <>
                                                    {Number(data.getThermalData.companyInfo.upi_amount) > 0 && " UPI"}
                                                    {Number(data.getThermalData.companyInfo.card_amount) > 0 && " CARD"}
                                                    {Number(data.getThermalData.companyInfo.cash_amount) > 0 && " CASH"}
                                                </>
                                            }
                                        </TableCell>
                                        <TableCell colSpan={2} sx={{ border: 'none !important' }} />
                                        {!isOthersEnterprise && <TableCell sx={{ border: 'none !important' }} />}
                                        <TableCell sx={{ color: 'black', fontSize: 13, border: 'none !important' }} align='right'>
                                            {data.getThermalData.companyInfo.mode === 'card' && (
                                                <span>
                                                    {Math.round(
                                                        parseFloat(data.getThermalData.TotalData.sub_total) +
                                                        parseFloat(data.getThermalData.TotalData.gst) +
                                                        parseFloat(data.getThermalData.companyInfo.discount_amount) -
                                                        data.getThermalData.companyInfo.discount_amount -
                                                        data.getThermalData.companyInfo.loyalty_redem -
                                                        data.getThermalData.companyInfo.less_amount
                                                    ) - parseFloat(data.getThermalData.TotalData.returnAmnt)}
                                                </span>
                                            )}
                                            {data.getThermalData.companyInfo.mode === 'cash' && (
                                                <span>
                                                    {Math.round(
                                                        parseFloat(data.getThermalData.TotalData.sub_total) +
                                                        parseFloat(data.getThermalData.TotalData.gst) +
                                                        parseFloat(data.getThermalData.companyInfo.discount_amount) -
                                                        data.getThermalData.companyInfo.discount_amount -
                                                        data.getThermalData.companyInfo.loyalty_redem -
                                                        data.getThermalData.companyInfo.less_amount
                                                    ) - parseFloat(data.getThermalData.TotalData.returnAmnt)}
                                                </span>
                                            )}
                                            {data.getThermalData.companyInfo.mode === 'upi' && (
                                                <span>
                                                    {Math.round(
                                                        parseFloat(data.getThermalData.TotalData.sub_total) +
                                                        parseFloat(data.getThermalData.TotalData.gst) +
                                                        parseFloat(data.getThermalData.companyInfo.discount_amount) -
                                                        data.getThermalData.companyInfo.discount_amount -
                                                        data.getThermalData.companyInfo.loyalty_redem -
                                                        data.getThermalData.companyInfo.less_amount
                                                    ) - parseFloat(data.getThermalData.TotalData.returnAmnt)}
                                                </span>
                                            )}
                                            {data.getThermalData.companyInfo.mode === 'mixed' && (
                                                <>
                                                    {Number(data.getThermalData.companyInfo.card_amount) > 0 && (
                                                        <div>{Math.round(data.getThermalData.companyInfo.card_amount)}</div>
                                                    )}
                                                    {Number(data.getThermalData.companyInfo.upi_amount) > 0 && (
                                                        <div>{Math.round(data.getThermalData.companyInfo.upi_amount)}</div>
                                                    )}
                                                    {Number(data.getThermalData.companyInfo.cash_amount) > 0 && (
                                                        <div>{Math.round(data.getThermalData.companyInfo.cash_amount)}</div>
                                                    )}
                                                </>
                                            )}
                                        </TableCell>
                                    </TableRow>
                                </TableBody>
                            </Table>
                        </TableContainer>

                        {!isOthersEnterprise &&
                            <TableContainer sx={{ padding: 1, color: 'black', }}>
                                <Table>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell className={classes.headCell}>Tax %</TableCell>
                                            <TableCell align='center' sx={{ color: 'black' }} className={classes.headCell}>CGST</TableCell>
                                            <TableCell align='center' sx={{ color: 'black' }} className={classes.headCell}>SGST</TableCell>
                                            <TableCell align='right' sx={{ color: 'black' }} className={classes.headCell}>Total</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {_.map(gst, (val, idx) => (
                                            <TableRow className={classes.tblRowCell} key={idx}>
                                                <TableCell sx={{ color: 'black' }}>{parseFloat(val.cgstPerc).toFixed(2)}</TableCell>
                                                <TableCell sx={{ color: 'black' }} align='right'>{parseFloat(val.gstAmt / 2).toFixed(2)}</TableCell>
                                                <TableCell sx={{ color: 'black' }} align='right'>{parseFloat(val.gstAmt / 2).toFixed(2)}</TableCell>
                                                <TableCell sx={{ color: 'black' }} align='right'>{parseFloat(val.gstAmt).toFixed(2)}</TableCell>
                                            </TableRow>
                                        ))}
                                        <TableRow className={classes.tblSubCell}>
                                            <TableCell className={classes.headCell}>Total</TableCell>
                                            <TableCell align='right' className={classes.headCell}>{parseFloat((data.getThermalData.tableData.reduce((accumulator, currentValue) => accumulator + Number(currentValue.cgstAmnt), 0) / 2)).toFixed(2)}</TableCell>
                                            <TableCell align='right' className={classes.headCell}>{parseFloat((data.getThermalData.tableData.reduce((accumulator, currentValue) => accumulator + Number(currentValue.cgstAmnt), 0) / 2)).toFixed(2)}</TableCell>
                                            <TableCell align='right' className={classes.headCell}>{parseFloat(data.getThermalData.tableData.reduce((accumulator, currentValue) => accumulator + Number(currentValue.cgstAmnt), 0)).toFixed(2)}</TableCell>
                                        </TableRow>
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        }

                        {isOthersEnterprise && <Divider sx={{ backgroundColor: 'black', margin: 1 }} />}
                        <Fragment>
                            {isOthersEnterprise && <Typography fontWeight={600} width={300} align='center' flexWrap='wrap' sx={{ color: 'black' }}>Composition Dealer: Not eligible to collect tax on supplies</Typography>}

                            <Typography fontWeight={600} fontSize={12} marginLeft={2} sx={{ color: 'black' }}>Terms and Condition:</Typography>
                            <Typography fontWeight={600} fontSize={12} marginLeft={2} sx={{ color: 'black' }}>*Goods received in good condition.</Typography>
                            <Typography fontWeight={600} fontSize={12} marginLeft={2} sx={{ color: 'black' }}>*No exchange and No Return</Typography>
                        </Fragment>

                        <Typography textAlign='center' fontWeight={600} sx={{ color: 'black', fontSize: 13 }}>Order Online: www.buygirlush.com</Typography>
                        <Typography textAlign='center' fontWeight={600} sx={{ color: 'black', fontSize: 13 }}>***  THANK YOU! VISIT AGAIN ***</Typography>
                        <Cut />

                    </Printer>
                </div>}
        </div>
    );
};

export default memo(ThermalPrint);
